import React, {SVGAttributes} from 'react'

const Twitter: React.FC<SVGAttributes<SVGElement>> = (props) => (
  <svg height={300} width={244.19} viewBox="0 0 300 244.19" fill="#FFF" {...props}>
    <path d="M94.72 243.19c112.46 0 173.96-93.17 173.96-173.96 0-2.65-.06-5.28-.18-7.9A124.32 124.32 0 0 0 299 29.67a121.91 121.91 0 0 1-35.11 9.62 61.35 61.35 0 0 0 26.89-33.81c-11.82 7-24.9 12.09-38.83 14.84a61.15 61.15 0 0 0-104.19 55.76 173.59 173.59 0 0 1-126.02-63.9 60.98 60.98 0 0 0-8.28 30.73 61.1 61.1 0 0 0 27.2 50.9 60.69 60.69 0 0 1-27.68-7.65l-.01.78a61.16 61.16 0 0 0 49.05 59.93 61.22 61.22 0 0 1-27.61 1.05 61.2 61.2 0 0 0 57.11 42.47 122.65 122.65 0 0 1-75.94 26.17c-4.92 0-9.8-.28-14.58-.85a173.07 173.07 0 0 0 93.72 27.47" />
  </svg>
)

export default Twitter
